// @ts-nocheck
import {PropTypes} from "prop-types";
import {BaseInputNumber} from "@/components";

const BoxBetsSelected = props => {
  const {
    animalsSelected,
    betAmount,
    handleBetAmountChange,
    betAmountError,
    isBetAmountValid,
    minBetAmount = 15,
    maxBetAmount = 45,
  } = props;

  const borderColor = betAmountError
    ? "var(--color-danger)"
    : isBetAmountValid
      ? "var(--color-success)"
      : "var(--color-border)";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "var(--space-3-5)",
        padding: "12px 24px",
        borderRadius: "var(--radius-md)",
        border: "1px solid var(--color-border)",
        backgroundColor: "var(--color-surface)",
      }}
    >
      <div
        style={{display: "flex", flex: 1, width: "100%", justifyContent: "center", padding: "0 40px", flexWrap: "wrap"}}
      >
        {animalsSelected.length > 0 &&
          animalsSelected.map((animal, key) => (
            <div
              // biome-ignore lint/suspicious/noArrayIndexKey: list may contain repeated animal ids; index disambiguates
              key={`${key}-${animal.id}`}
              style={{display: "flex", flexDirection: "column", alignItems: "center", padding: "5px 0"}}
            >
              <img
                key={animal.id}
                src={animal.img_f}
                alt={animal.nombre}
                style={{
                  width: "var(--size-20)",
                  height: "var(--size-20)",
                  objectFit: "contain",
                  margin: "var(--space-1-5)",
                }}
              />
            </div>
          ))}
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          gap: "var(--space-3-5)",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          marginTop: "var(--space-3-5)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <span style={{color: "var(--color-text-primary)", fontWeight: "bold"}}>Monto de apuesta:</span>
          <span
            style={{
              color: "var(--color-text-secondary)",
              fontSize: "var(--font-body)",
              fontStyle: "italic",
            }}
          >
            Min: {minBetAmount}Bs - Max: {maxBetAmount}Bs
          </span>
        </div>

        <div style={{width: "100%"}}>
          <BaseInputNumber
            value={betAmount}
            onChange={handleBetAmountChange}
            placeholder={`Entre ${minBetAmount} y ${maxBetAmount} Bs`}
            min={minBetAmount}
            max={maxBetAmount}
            style={{
              width: "100%",
              borderColor,
            }}
          />

          {betAmountError && (
            <div
              style={{
                color: "var(--color-danger-text)",
                fontSize: "var(--font-body)",
                marginTop: "var(--space-1)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{marginRight: "var(--space-1)"}}>⚠</span>
              {betAmountError}
            </div>
          )}

          {isBetAmountValid && !betAmountError && (
            <div
              style={{
                color: "var(--color-success-text)",
                fontSize: "var(--font-body)",
                marginTop: "var(--space-1)",
                display: "flex",
                alignItems: "center",
              }}
            >
              <span style={{marginRight: "var(--space-1)"}}>✓</span>
              Monto válido
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

BoxBetsSelected.propTypes = {
  animalsSelected: PropTypes.array.isRequired,
  betAmount: PropTypes.number,
  handleBetAmountChange: PropTypes.func.isRequired,
  betAmountError: PropTypes.string,
  isBetAmountValid: PropTypes.bool,
  minBetAmount: PropTypes.number,
  maxBetAmount: PropTypes.number,
};

export default BoxBetsSelected;
